import { ApolloCache } from '@apollo/client';
import { WORLD_MAP_SET_FRAGMENT } from 'graphql/fragment/worldFragment';
import { WorldMapSets_worldMap_worldMapSets } from 'graphql/query/__generated__/WorldMapSets';
import { PartialDeep } from 'type-fest';

export const cacheAddWorldMapSet = (
    cache: ApolloCache<unknown>,
    worldMapId: string,
    data: PartialDeep<WorldMapSets_worldMap_worldMapSets>
) => {
    cache.modify({
        id: cache.identify({
            __typename: 'WorldMap',
            worldMapId: worldMapId
        }),
        fields: {
            worldMapSets: (existing): WorldMapSets_worldMap_worldMapSets[] => {
                const exists = existing.some((e) => e.worldMapSetId === data.worldMapSetId);
                if (exists) {
                    return existing;
                }
                const newSetRef = cache.writeFragment<WorldMapSets_worldMap_worldMapSets>({
                    data: {
                        ...(data as WorldMapSets_worldMap_worldMapSets),
                        __typename: 'WorldMapSet'
                    },
                    fragment: WORLD_MAP_SET_FRAGMENT
                });
                return [...existing, newSetRef];
            }
        }
    });
};

export const cacheUpdateWorldMapSet = (
    cache: ApolloCache<unknown>,
    worldMapId: string,
    data: PartialDeep<WorldMapSets_worldMap_worldMapSets>
) => {
    cache.modify({
        id: cache.identify({
            __typename: 'WorldMap',
            worldMapId: worldMapId
        }),
        fields: {
            worldMapSets: (existing): PartialDeep<WorldMapSets_worldMap_worldMapSets>[] => {
                return existing.map((e) => (e.worldMapSetId === data.worldMapSetId ? data : e));
            }
        }
    });
};

export const cacheRemoveWorldMapSet = (
    cache: ApolloCache<unknown>,
    worldMapId: string,
    worldMapSetId: string
) => {
    cache.modify({
        id: cache.identify({
            __typename: 'WorldMap',
            worldMapId: worldMapId
        }),
        fields: {
            worldMapSets: (data): WorldMapSets_worldMap_worldMapSets[] => {
                return data.filter((e) => e.worldMapSetId !== worldMapSetId);
            }
        }
    });
    const removeId = cache.identify({
        __typename: 'WorldMapSet',
        worldMapSetId
    });
    cache.evict({ id: removeId });
    cache.gc();
};
